<template>
  <SimpleCrud
    :headers="headers"
    :name="name"
    :scheme="scheme"
    :canWrite="!disabled"
    :canDetail="false"
    :canAdd="!disabled"
    :canDelete="!disabled"
    :merge_new_item="merge_item"
    :logicDelete="false"
    @open-file="open_auth_file">
    <template slot="crud-title">
      <h5 class="sub_t" style="color:black">Documentos Adjuntos</h5>
    </template>
    <template slot="write-title">Documento</template>
    <template v-slot:document="{ item, value }">
      <fs1 tag="td" class="width150px">
        <v-progress-circular v-if="is_auth_file_opening(item)" indeterminate color="primary" size="20" width="2"/>
        <v-icon v-else-if="resolveAuthFileUrl(item)" class="pointer_hover" @click="open_auth_file(item)">insert_drive_file</v-icon>
        <a v-else-if="value && !isProtectedUploadUrl(value)" :href="value" target="_blank" class="tableM1_file">
          <v-icon>insert_drive_file</v-icon>
        </a>
      </fs1>
    </template>
    <template slot-scope="{ selectedItem }" slot="write">
        <table style="width: 100%;">
          <tr>
            <td class="pa-2"><b>Nombre</b></td>
            <td class="pa-2">
              <in-text v-model="selectedItem.name" placeholder=" ingresar texto" :condensed="true"/>
            </td>
            <td class="pa-2">
              <v-icon @click="selectedItem.name = null">clear</v-icon>  
            </td>
          </tr>
          <tr>
            <td class="pa-2"><b>Archivo</b></td>
            <td class="pa-2">
              <in-file :value.sync="selectedItem.document"/>
            </td>
            <td class="pa-2"><v-icon @click="selectedItem.status=0;selectedItem.document = null">clear</v-icon></td>
          </tr>
        </table>
    </template>
  </SimpleCrud>
</template>
<script>
import {v4 as uuid} from 'uuid';
import filter from '@/components/mixins/filter';
import open_auth_file from '@/mixins/open_auth_file';
export default {
  mixins:[filter, open_auth_file],
  props:['name','disabled','merge_item','ex_filters'],
  data(){
    return {
      id: uuid(),
      scheme: {
        name: {type: 'string'},
        document: {type: 'file'},
        finding: {type:'int'},
      }
    }
  },
  computed: {
    headers() {
      const hs = [
        { text: 'Nombre del documento', value:'name', class: 'text_align_left'},
        { text: 'Archivo', value:'document', class: 'width150px',  align:'center'},
      ]
      if (!this.disabled) hs.push({ text: '',value: 'actions', class: 'width100px'});
      return hs;
    },
    rq_name() {return this.name},
  },
  watch:{
    'ex_filters':{
      deep: true,
      handler(v){ 
        if (!this.filter || !v) return;
        if (this.filter.fire_protection_system != v.fire_protection_system) this.get_data();
      }
    },
  },
  created() {
    this.get_data();
  },
  methods: {
    selectFile(item, files) { // files no es un array por lo que sus proto funciones no aplican
      item./* file */document = files[0]
      item.status = 1;
      const reader = new FileReader();
      reader.onload = e => item.status = 2;
      reader.readAsDataURL(files[0]);
		},
    resetRqStatus(){
      this.myRequestStatus.status = false;
      this.myRequestStatus.ticking = false;
    },
    get_data(){
      if (this.myRequestStatus) this.resetRqStatus();
      Object.assign(this.filter, this.ex_filters);
      const filter = {...this.filter};
      Object.keys(filter).forEach(k => [undefined,null].includes(filter[k]) && (delete filter[k]));
      this.requests.gets[`${this.name}/a/all`](filter);
    }
  },
};
</script>
